<template>
  <v-row no-gutters>
    <v-col>
      <v-row no-gutters>
        <v-toolbar dense flat color="white" height="45px" class="mt-1">
          <v-toolbar-title class="headline primary--text">Admin Dashboard</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              text
              color="primary"
              class="font-weight-bold px-0 mr-2"
              @click="onClick('adminaccount')"
            >
              <v-icon size="18" class="mr-1">mdi-account-circle</v-icon>ACCOUNT USERS
            </v-btn>

            <v-divider vertical inset></v-divider>

            <!-- <v-btn
              text
              color="primary"
              class="font-weight-bold px-0 mx-2"
              @click="onClick('adminfiletypes')"
            >
              <v-icon size="18" class="mr-1">mdi-file</v-icon>FILE TYPES
            </v-btn>

            <v-divider vertical inset></v-divider>-->

            <v-btn
              text
              color="primary"
              class="font-weight-bold px-0 mx-2"
              @click="onClick('admincustomerrank')"
            >
              <v-icon size="18" class="mr-1">mdi-seal</v-icon>CUSTOMER RANK
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              color="primary"
              class="font-weight-bold px-0 ml-2"
              @click="onClick('admincompany')"
            >
              <v-icon size="18" class="mr-1">mdi-domain</v-icon>COMPANIES
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-row>

      <v-row>
        <v-divider class="my-0 py-0"></v-divider>
      </v-row>

      <!-- Router view -->
      <v-row no-gutters>
        <router-view />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import constant from "../../const"

export default {
  created() {},

  mounted() {
    if (this.$store.state.user.role != constant.ACCOUNT_ADMIN) {
      this.$router.replace({ name: "user" })
    } else {
      this.$router.push({ name: "adminaccount" })
      // if (this.$route.name == "admindashboard") {
      // }
    }
  },

  methods: {
    onClick(routeName) {
      var name = null
      this.$router.push({ name: routeName })
    },
  },
}
</script>

<style>
</style>

